export default "__VITE_ASSET__pa$bRrRl__"